import { clearProject } from '../State/project';

export default () => (dispatch) => {

  dispatch(clearProject());
  
}